import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, transientOptions } from "shared/lib/styles";

import { Loading } from "scmp-app/components/common/loading";
import { SpinnerIcon } from "scmp-app/components/common/loading/styles";

export const Text = styled.div`
  font-size: 14px;
  line-height: 16px;
`;

export const SwitchThumb = styled.span`
  position: absolute;
  inset-inline-start: 0;

  inline-size: auto;
  block-size: calc(100% - 4px);
  aspect-ratio: 1;

  margin: 2px;

  border-radius: inherit;

  background-color: #ffffff;

  transition: inset-inline-start 0.12s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const SwitchTrack = styled.span`
  position: absolute;
  inset-block-start: 0;

  inline-size: 100%;
  block-size: 100%;

  border-radius: inherit;

  background: #9e9e9e;
`;

export const SwitchInput = styled.input`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;

  inline-size: 100%;
  block-size: 100%;

  cursor: pointer;

  opacity: 0;
`;

type SwitchRootProps = {
  $isChecked: boolean;
};

export const SwitchRoot = styled.span<SwitchRootProps>`
  position: relative;

  inline-size: auto;
  aspect-ratio: 1.54;

  block-size: 24px;

  border-radius: 30px;

  ${props =>
    props.$isChecked
      ? css`
          ${SwitchTrack} {
            background-color: #001246;
          }
          ${SwitchThumb} {
            inset-inline-start: 13px;
          }
        `
      : null}
`;

export const StyledLoading = styled(Loading)`
  inline-size: 24px;
  block-size: 24px;
  margin-inline: 10px 4px;

  opacity: 0;

  pointer-events: none;

  ${SpinnerIcon} {
    inline-size: 24px;
  }
`;

type ContainerProps = {
  $isDisabled: boolean;
  $isLoading: boolean;
};

export const Container = styled("div", { ...transientOptions })<ContainerProps>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  inline-size: max-content;
  block-size: 64px;
  padding: 20px;
  padding-block: 16px;
  padding-inline: 20px;

  font-family: ${fontRoboto};

  border-radius: 64px;

  background-color: #f2f2f2;

  ${props =>
    props.$isLoading
      ? css`
          ${StyledLoading} {
            opacity: 1 !important;
          }
        `
      : null}

  ${props =>
    props.$isDisabled
      ? css`
          ${SwitchRoot} {
            opacity: 0.3 !important;
          }
          ${SwitchInput} {
            cursor: default !important;
          }
        `
      : null}
`;
